import { GlobalTimerManager, TimerTick } from './timer.ts';

/**
 * 타이머 구독 가능한 컴포넌트 인터페이스
 */
export interface ITimerSubscribable {
  onTimerTick(event: TimerTick): void;
  destroy(): void;
}

export class TimerSubscriptionManager {
  private timerManager = GlobalTimerManager.getInstance();

  private unsubscribeCallback?: () => void;

  constructor(private timerSubscriber: ITimerSubscribable) {}

  // 구독 시작
  subscribe(): void {
    if (this.unsubscribeCallback) {
      console.warn('이미 구독중입니다.');
      return;
    }

    this.unsubscribeCallback = this.timerManager.subscribe((event) => {
      this.timerSubscriber.onTimerTick(event);
    });
  }

  // 구독 해제
  unsubscribe(): void {
    if (this.unsubscribeCallback) {
      this.unsubscribeCallback();
      this.unsubscribeCallback = undefined;
    }
  }

  // 현재 구독 상태 확인
  get isSubscribed(): boolean {
    return !!this.unsubscribeCallback;
  }

  // 구독 재시작 (일시정지 후 재개용)
  resubscribe(): void {
    this.unsubscribe();
    this.subscribe();
  }
}
